import { Column } from '@tanstack/react-table';

import { SessionSchema } from '@/types/schema';

import { ACCESSOR_FNS, BASE_CHARTABLE_COLUMN_IDS } from '../constants';

export const getChartableColumns = (
  columnsToDisplay: Column<SessionSchema, unknown>[]
) => {
  return [
    ...BASE_CHARTABLE_COLUMN_IDS,
    ...columnsToDisplay
      .filter(
        (column) =>
          column.id?.startsWith('feedback_stats_') ||
          column.id?.startsWith('session_feedback_stats_')
      )
      .map((column) => column.id ?? ''),
  ];
};

export const getDefaultSelectedColumns = (chartableColumns: string[]) => {
  const defaultSelectedColumns = chartableColumns
    .filter((col) => col.startsWith('session_feedback_stats_'))
    .slice(0, 3);

  if (defaultSelectedColumns.length < 3) {
    defaultSelectedColumns.push(
      ...chartableColumns
        .filter((col) => col.startsWith('feedback_stats_'))
        .slice(0, 3 - defaultSelectedColumns.length)
    );
  }

  if (defaultSelectedColumns.length === 0) {
    defaultSelectedColumns.push('latency_p50');
  }

  return defaultSelectedColumns;
};

export const createAccessorFns = (chartableColumns: string[]) => {
  const accessorFns = { ...ACCESSOR_FNS };

  chartableColumns.forEach((column) => {
    if (column.startsWith('feedback_stats_')) {
      const type = column.split('feedback_stats_')[1];
      accessorFns[column] = (row: SessionSchema) =>
        ACCESSOR_FNS['feedback_stats'](type, row);
    } else if (column.startsWith('session_feedback_stats_')) {
      const type = column.split('session_feedback_stats_')[1];
      accessorFns[column] = (row: SessionSchema) =>
        ACCESSOR_FNS['session_feedback_stats'](type, row);
    } else {
      accessorFns[column] = (row: SessionSchema) => row[column];
    }
  });

  return accessorFns;
};
